import React, { useState } from "react";
import { connect } from "react-redux";
import { DatePicker } from "react-advance-jalaali-datepicker";
import helpersTime from "../../../helpers/time";
import reportAction from "../../../store/actions/reportAction";
import constantsReportCampaign from "./constants/WhichTypeSelect";
import eventAdvertise from "../../../store/actions/eventAdvertise";

const FilterDateReport = ({
  whichTypeSelect,
  setDateReportFilter,
  getReportAllWebSitePublisher,
  getReportWebSitePublisher,
  getReportAllWebSitePublisherDataChart,
  getReportWebSitePublisherDataChart,
  getReportWebSitePublisherDataChartSeparation,
  getReportAllWebSitePublisherDataChartSeparation,
  sitePublisherID,
  separation,
}) => {
  const [activeDatePicker, setActiveDatePicker] = useState(false);
  const [
    activeBtnGetReportWithDatePicker,
    setActiveBtnGetReportWithDatePicker,
  ] = useState(false);

  const clickBtnDateFilterHandler = (e, countDays) => {
    let dateFrom = helpersTime.addStartTime(
      helpersTime.getLastDayDate(countDays + 1)
    );
    let dateTo = helpersTime.addStartTime(
      helpersTime.getLastDayDate(countDays)
    );

    if (countDays > 0) {
      dateFrom = helpersTime.addStartTime(
        helpersTime.getLastDayDate(countDays)
      );
      dateTo = helpersTime.addStartTime(helpersTime.getLastDayDate(0));
    }
    // changeClassesBtn(e);
    setActiveDatePicker(false);
    setActiveBtnGetReportWithDatePicker(false);
    setDateReportFilter({ date_from: dateFrom, date_to: dateTo });
    getReportDataWithDateFilter(dateFrom, dateTo);
  };

  const getReportDataWithDateFilter = (dateFrom, dateTo) => {
    const eventReport = eventAdvertise.eventAdvertiseString.VIEW;
    switch (whichTypeSelect) {
      case constantsReportCampaign.ALL_SITE_PUBLISHER:
        getReportAllWebSitePublisher({
          dateFrom,
          dateTo,
        });
        getReportAllWebSitePublisherDataChart({
          dateFrom,
          dateTo,
          eventReport,
        });
        getReportAllWebSitePublisherDataChartSeparation({
          dateFrom,
          dateTo,
        });
        break;
      case constantsReportCampaign.SPECIFIC_SITE_PUBLISHER:
        getReportWebSitePublisher({
          site_publisher_ID: sitePublisherID,
          date_from: dateFrom,
          date_to: dateTo,
        });
        getReportWebSitePublisherDataChart({
          dateFrom,
          dateTo,
          sitePublisherID,
          eventReport,
        });
        getReportWebSitePublisherDataChartSeparation({
          sitePublisherID,
          dateFrom,
          dateTo,
          separation,
        });
        break;
    }
  };

  const changeClassesBtn = (e) => {
    const lastBtnClicked = document.querySelector("button.btn-outline-warning");
    lastBtnClicked.classList.remove("btn-outline-warning");
    lastBtnClicked.classList.remove("text-warning");
    lastBtnClicked.classList.add("btn-secondary text-dark ");
    lastBtnClicked.classList.add("");

    const btnClicked = e.target;
    btnClicked.classList.remove("btn-secondary text-dark ");
    btnClicked.classList.remove("");
    btnClicked.classList.add("text-warning");
    btnClicked.classList.add("btn-outline-warning");
  };

  const clickBtnRateDateFilterHandler = (e) => {
    // changeClassesBtn(e);
    setActiveDatePicker(true);
    setActiveBtnGetReportWithDatePicker(true);
  };

  const clickBtnGetReportCampaignRateDateFilterHandler = (e) => {
    let dateFrom = document.querySelector("#date-from").value;
    dateFrom = helpersTime.convertJalaliToGregorian(dateFrom);
    dateFrom = helpersTime.addStartTime(
      dateFrom.replace("/", "-").replace("/", "-")
    );

    let dateTo = document.querySelector("#date-to").value;
    dateTo = helpersTime.convertJalaliToGregorian(dateTo);
    dateTo = helpersTime.addStartTime(
      dateTo.replace("/", "-").replace("/", "-")
    );
    setDateReportFilter({ date_from: dateFrom, date_to: dateTo });
    getReportDataWithDateFilter(dateFrom, dateTo);
  };

  return (
    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 py-2 px-0">
      <div className="container-fluid">
        <div className="row">
          <div
            className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5 "
            id="nav-tab-date-filter"
          >
            <nav>
              <div class="nav nav-tabs d-flex flex-lg-nowrap" role="tablist">
                <a
                  class="nav-item nav-link hover text-dark "
                  data-toggle="tab"
                  role="tab"
                  aria-selected="false"
                  onClick={(e) => {
                    clickBtnDateFilterHandler(e, -1);
                  }}
                >
                  امروز
                </a>
                <a
                  class="nav-item nav-link hover text-dark active"
                  data-toggle="tab"
                  role="tab"
                  aria-selected="true"
                  onClick={(e) => {
                    clickBtnDateFilterHandler(e, 0);
                  }}
                >
                  دیروز
                </a>
                <a
                  class="nav-item nav-link hover text-dark"
                  data-toggle="tab"
                  role="tab"
                  aria-selected="false"
                  onClick={(e) => {
                    clickBtnDateFilterHandler(e, 7);
                  }}
                >
                  ۷ روز گذشته
                </a>
                <a
                  class="nav-item nav-link hover text-dark"
                  data-toggle="tab"
                  role="tab"
                  aria-selected="false"
                  onClick={(e) => {
                    clickBtnDateFilterHandler(e, 30);
                  }}
                >
                  ۳۰ روز گذشته
                </a>
                <a
                  class="nav-item nav-link hover text-dark"
                  data-toggle="tab"
                  role="tab"
                  aria-selected="false"
                  onClick={clickBtnRateDateFilterHandler}
                >
                  انتخاب بازه
                </a>
              </div>
            </nav>
          </div>
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5">
            <div className="d-flex flex-column h-100 flex-xl-row py-2 py-lg-0  align-xl-items-center justify-content-xl-around ">
              <div
                className={`d-flex my-2 my-lg-0 bg-success filter-date-input-container ${
                  activeDatePicker ? "" : " opacity-50 "
                } `}
              >
                <span className="d-flex align-items-center  text-dark px-2">
                  از
                </span>
                <span
                  className="custom-data-picker d-flex align-items-center p-0 pr-2 btn-date-picker bg-secondary "
                  // style={{ width: "120px" }}
                >
                  <DatePicker
                    cancelOnBackgroundClick={true}
                    inputComponent={(props) => {
                      return (
                        <input
                          disabled={!activeDatePicker}
                          className="w-100 p-0 border-0 bg-secondary text-center"
                          {...props}
                        />
                      );
                    }}
                    placeholder="انتخاب تاریخ"
                    format="jYYYY/jMM/jDD"
                    className="w-100 disabled"
                    preSelected={helpersTime.getDateNowJalali()}
                    id="date-from"
                  />
                </span>
              </div>
              <div
                className={`d-flex my-2 my-lg-0 bg-success filter-date-input-container
              ${activeDatePicker ? "" : " opacity-50 "} `}
              >
                <span className="d-flex align-items-center px-2 text-dark">
                  تا
                </span>
                <span
                  className="custom-data-picker d-flex align-items-center p-0 pr-2 btn-date-picker bg-secondary"
                  // style={{ width: "120px" }}
                >
                  <DatePicker
                    cancelOnBackgroundClick={true}
                    inputComponent={(props) => {
                      return (
                        <input
                          disabled={!activeDatePicker}
                          className="w-100 p-0 border-0 bg-secondary text-center"
                          {...props}
                        />
                      );
                    }}
                    id="date-to"
                    placeholder="انتخاب تاریخ"
                    format="jYYYY/jMM/jDD"
                    className="w-100 disabled"
                    preSelected={helpersTime.getDateNowJalali()}
                  />
                </span>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-2  ">
            <div className="text-left">
              <button
                className="btn btn-success text-dark w-100 "
                disabled={!activeBtnGetReportWithDatePicker}
                onClick={clickBtnGetReportCampaignRateDateFilterHandler}
              >
                مشاهده گزارش
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    whichTypeSelect: state.report.which_type_select,
    sitePublisherID: state.report.site_publisher_ID,
    separation: state.report.separation_data_chart,
    // campaignTypeCategorySelected:
    //   state.reportCampaign.campaign_type_category_selected,
    // eventDataChart: state.reportCampaign.event_data_chart,
    // whichSeparationActive: state.reportCampaign.which_separation_active,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setDateReportFilter: (action) => {
      dispatch({
        type: reportAction.SET_DATE_REPORT_FILTER,
        payload: action,
      });
    },
    getReportAllWebSitePublisher: (action) => {
      dispatch({
        type: reportAction.GET_REPORT_ALL_WEB_SITE_PUBLISHER,
        payload: action,
      });
    },
    getReportWebSitePublisher: (action) => {
      dispatch({
        type: reportAction.GET_REPORT_WEB_SITE_PUBLISHER,
        payload: action,
      });
    },
    getReportAllWebSitePublisherDataChart: (action) => {
      dispatch({
        type: reportAction.GET_REPORT_ALL_WEB_SITE_PUBLISHER_DATA_CHART,
        payload: action,
      });
    },
    getReportWebSitePublisherDataChart: (action) => {
      dispatch({
        type: reportAction.GET_REPORT_WEB_SITE_PUBLISHER_DATA_CHART,
        payload: action,
      });
    },
    getReportWebSitePublisherDataChartSeparation: (action) => {
      dispatch({
        type: reportAction.GET_SITE_PUBLISHER_SEPARATION_DATA_CHART,
        payload: action,
      });
    },
    getReportAllWebSitePublisherDataChartSeparation: (action) => {
      dispatch({
        type: reportAction.GET_ALL_SITE_PUBLISHER_SEPARATION_DATA_CHART,
        payload: action,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterDateReport);
